export const AI_REPORTS_PATH = "/reports/ai";
export const AI_REPORTS_ROUTE = `${AI_REPORTS_PATH}/:relicId?`;
